import { useNavigate } from 'react-router';
import { enableModalConfirmationAutofocus } from '@gonfalon/dogfood-flags/dogfood-flags';
import { toSecurity } from '@gonfalon/navigator/navigators';
import { Button, Dialog, Heading, IconButton, Modal, ModalOverlay } from '@launchpad-ui/components';

import { Stack } from '../Stack';
import { Text } from '../Text';

type Props = {
  product: string;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
};

export const EnableSettingModal: React.FC<Props> = ({ isOpen, onOpenChange, product }) => {
  const navigate = useNavigate();

  return (
    <ModalOverlay isOpen={isOpen} onOpenChange={onOpenChange}>
      <Modal>
        <Dialog>
          {({ close }) => (
            <>
              <div slot="header">
                <Heading slot="title">Enable AI Features</Heading>
                <IconButton aria-label="Close modal" variant="minimal" icon="cancel" size="small" onPress={close} />
              </div>
              <div slot="body">
                <Stack py="8" style={{ minWidth: 300, maxWidth: 500 }}>
                  <Text size="small" color="secondaryContentText">
                    To use AI-powered {product}, you need to enable generative AI use cases in your security settings.
                  </Text>
                </Stack>
              </div>
              <div slot="footer">
                <Stack direction="row" gap="8" justifyContent="flex-end">
                  <Button variant="default" onPress={close}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    autoFocus={enableModalConfirmationAutofocus()}
                    onPress={() => {
                      close();
                      void navigate(toSecurity({ hash: 'enable-genai' }));
                    }}
                  >
                    Go to Settings
                  </Button>
                </Stack>
              </div>
            </>
          )}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
};
